import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { API } from "@/lib/api";
import { Eyebrow } from "./Brand";
import { Reveal } from "./Motion";

export const BlogTeaser = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog/latest`)
      .then(({ data }) => setPosts(Array.isArray(data?.items) ? data.items : []))
      .catch(() => setPosts([]));
  }, []);

  return (
    <section className="py-20 sm:py-28 bg-[#F7F9FC] border-t border-slate-200" data-testid="blog-teaser-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-10">
        <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-5">
          <div>
            <Eyebrow>From the blog</Eyebrow>
            <h2 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-[#13296B] mt-4">Latest from the blog</h2>
          </div>
          <a href="/blog" data-testid="blog-teaser-all-link" className="group inline-flex items-center gap-2 font-bold text-[#13296B] hover:text-[#2F7FF0] transition-colors">
            All articles <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </Reveal>
        {posts.length === 0 ? (
          <p className="mt-10 text-slate-600" data-testid="blog-teaser-empty">First articles are on the way. Check back soon.</p>
        ) : (
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
            {posts.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.08}>
                <a href={`/blog?post=${encodeURIComponent(p.slug)}`} data-testid={`blog-teaser-card-${i + 1}`} className="group block h-full rounded-[24px] bg-white ring-1 ring-slate-200 overflow-hidden hover:-translate-y-1 transition-transform duration-500">
                  {p.imageUrl && <div className="aspect-[16/10] overflow-hidden"><img src={p.imageUrl} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" /></div>}
                  <div className="p-6">
                    <p className="font-mono text-xs uppercase tracking-[0.15em] text-slate-500">{p.date}</p>
                    <h3 className="font-display text-xl font-bold text-[#13296B] mt-2 leading-snug">{p.title}</h3>
                    <p className="mt-2 text-sm text-slate-600 line-clamp-3">{p.excerpt}</p>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
